import { gsap } from 'gsap';

const nav = {
	init() {

		async function lottieLogo() {
			gsap.fromTo(document.getElementById('header-logo'), {opacity: 0}, {opacity: 1, duration: 1});
			var animation = bodymovin.loadAnimation({
				// animationData: { /* ... */ },
				container: document.getElementById('header-logo'), // required
				path: '/wp-content/themes/kerve/mmm_logo.json', // required
				renderer: 'svg', // required
				loop: true, // optional
				autoplay: true, // optional
				name: "mmm logo animation", // optional
			});
		}
		lottieLogo().then(() => {
			setTimeout(doThis, 100);
			function doThis(){
				const logoWrapper = document.querySelector('#header-logo');
				const svg = logoWrapper.childNodes[0];
				const gs = svg.querySelectorAll('g');
				svg.setAttribute('preserveAspectRatio', 'none');
				svg.removeAttribute('defs');
				gs.forEach(function(g) {	  
					g.removeAttribute('filter');
				})
			}
		});

	},
};

export default nav;
